import { TableLayoutContract } from 'models'
import {
    UPDATE_TABLE_LAYOUT_CACHE,
    UPDATE_TABLE_LAYOUT_CACHE_STATUS,
} from 'store/actions/tableLayout.action'

interface ITableLayoutState {
    tableLayouts: TableLayoutContract[]
}

const initialState: ITableLayoutState = {
    tableLayouts: [],
}

export default function DrawerReducer(
    state: ITableLayoutState = initialState,
    action: any,
): ITableLayoutState {
    switch (action.type) {
        case UPDATE_TABLE_LAYOUT_CACHE: {
            return {
                ...state,
                tableLayouts: action.payload,
            }
        }
        case UPDATE_TABLE_LAYOUT_CACHE_STATUS: {
            return {
                ...state,
                tableLayouts: state.tableLayouts.map((i) => {
                    if (i.tables) {
                        i.tables = i.tables?.map((table) => {
                            if (table.tableID === action.tableID)
                                table.status = action.tableStatus
                            return table
                        })
                    }

                    return i
                }),
            }
        }
        default:
            return state
    }
}
